export const SpringAnimation = {
  INITIAL_X: 0,
  INITIAL_Y: 300,
  AFTER_X: 0,
  AFTER_Y: 0,
};

export const RELATION_OPTIONS = [
  { value: 'father', label: 'Father' },
  { value: 'mother', label: 'Mother' },
  { value: 'brother', label: 'Brother' },
  { value: 'sister', label: 'Sister' },
  { value: 'husband', label: 'Husband' },
  { value: 'wife', label: 'Wife' },
  { value: 'son', label: 'Son' },
  { value: 'daughter', label: 'Daughter' },
  { value: 'guest', label: 'Guest' }, // don't add this option while signup
];

export const RELATION = {
  father: 'Father',
  mother: 'Mother',
  brother: 'Brother',
  sister: 'Sister',
  husband: 'Husband',
  wife: 'Wife',
  son: 'Son',
  daughter: 'Daughter',
  guest: 'Guest',
};

export const DefaultRowsPerPage = 10;
